import { AuthListQueryParam, ListModelItems, queryKeys } from '../../shared';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { IResponseMessages } from '../../shared/models/response-messages.model';
import { roleClient } from '../clients/role.client';
import { IRole } from '../models';

const client = roleClient;
const key = queryKeys.ROLES;

export function useRoleList(params: AuthListQueryParam, messages?: IResponseMessages) {
    return useQuery<ListModelItems<IRole>, AxiosError>({
        queryKey: [key, params],
        queryFn: () => client.getList(params, messages),
    });
}
